import { DependenciesInjection } from "app/di/DependencyInjection";
import { B2BPackageImpl } from "features/packageManagement/b2bPackageManagement/data/B2BPackageManagementImpl";
import { IB2BPackageManagementRepository } from "features/packageManagement/b2bPackageManagement/domain/repositories/IB2BPackageManagementRepository";
import { B2BPackageManagementUseCase } from "features/packageManagement/b2bPackageManagement/domain/useCases/B2BPackageManagementUseCase";
import { B2BPackageManagementToken } from "./B2BPackageManagementToken";

export class B2BPackageManagementInjection {
  static injectB2BPackageManagement() {
    DependenciesInjection.register<IB2BPackageManagementRepository>(
      B2BPackageManagementToken.IB2BPackageManagementRepository,
      B2BPackageImpl,
      "otherRepo",
    );
    DependenciesInjection.register<B2BPackageManagementUseCase>(
      B2BPackageManagementToken.B2BPackageManagementUseCase,
      B2BPackageManagementUseCase,
      "otherRepo",
    );
  }

  static getRepo() {
    return DependenciesInjection.getRepo<IB2BPackageManagementRepository>(
      B2BPackageManagementToken.IB2BPackageManagementRepository,
    );
  }

  static getUseCase() {
    return DependenciesInjection.getRepo<B2BPackageManagementUseCase>(
      B2BPackageManagementToken.B2BPackageManagementUseCase,
    );
  }
}
